import FAPictureCard from './FAPictureCard'
export default FAPictureCard
